import React, { ReactElement } from 'react';
import classnames from 'classnames';

export interface SectionVisibilityProps {
  show: boolean;
}

export interface Props extends SectionVisibilityProps {
  title?: string;
  id?: string;
  description?: string;
  children: any;
  hideDivider?: boolean;
  className?: string;
  containerClassName?: string;
  titleClassName?: string;
}

export default function Section(props: Props): ReactElement {
  const { show, title, id, description, children, hideDivider, className, containerClassName, titleClassName } = props;

  return (
    <div id={id} className={classnames(containerClassName, !show && '!p-0 !m-0')}>
      {show && (
        <div
          className={classnames(
            'w-full lg:px-none lg:py-md p-lg lg:border-none',
            { 'border-t-[9px] border-[#F5F5F5]': !hideDivider },
            className,
          )}
        >
          {title && (
            <h5
              className={classnames(
                'text-sm',
                {
                  'mb-md': !description,
                  'mb-xs': !!description,
                },
                titleClassName,
              )}
            >
              {title}
            </h5>
          )}
          {Boolean(description) && <p className="mb-md text-xs text-brand-text-secondary font-medium">{description}</p>}
          {children}
        </div>
      )}
    </div>
  );
}
